export class authSoftwareHelper {
    static async getAuthSoftware(schoolData: { school_code: string }[]) {
        if (!schoolData || schoolData.length === 0) return [];

        const resp = await fetch(`/api/AuthSoftware/auth_software`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(schoolData)
        });
        return await resp.json() || [];
    }
}
